var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.515625 0.515625V22.8799H22.6362V0.515625H0.515625ZM11.5759 8.31406C13.4505 8.31406 14.969 9.8325 14.969 11.7071C14.969 13.5817 13.4505 15.0814 11.5759 15.0814C9.70128 15.0814 8.18284 13.563 8.18284 11.6884C8.18284 9.81376 9.70128 8.31406 11.5759 8.31406ZM20.7616 21.0053H2.39025V2.39025H10.6386V6.51442C8.18283 6.96433 6.30821 9.1014 6.30821 11.6884C6.30821 14.594 8.67024 16.9561 11.5759 16.9561C14.4816 16.9561 16.8436 14.594 16.8436 11.6884C16.8436 9.1014 14.969 6.94558 12.5132 6.51442V2.39025H20.7616V21.0053Z",
    fill: "#4780D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1206,
    height: 22.3643,
    fill: "#4780D6",
    transform: "translate(0.515625 0.515625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngage);
export default __webpack_public_path__ + "static/media/engage.f9d0381f38a9e00516400a544093359e.svg";
export { ForwardRef as ReactComponent };